module.exports = __webpack_public_path__ + "img/search-lookup.c1ba44cf.svg";